<template>
  <a-card :bordered="false">
    <SmallSquare content='用于提货码没有关联提货券、码被禁用、活动被禁用时显示；更换图片需点击保存' :padding='true'></SmallSquare>
    <a-form ref='form' :model='search' class="m-t-20" :style="{'marginBottom':'10px'}" :initialValues="search" :onFinish='pageSearchChange' :wrapper-col="{span:20}">
      <a-form-item label="上传图片" class='mb15' name='keyword' :label-col="{span:3}" help="建议：宽度750px，高度不限制，图片小于200k">
        <material :groupType='1' :image="detail.promotional_img"  :max="1" v-on:handlechoose="(data)=>{
                    detail.promotional_img=data}" v-on:handledel="detail.promotional_img=''"  :defaultImg="require('@/assets/images/assets/pickUpTopDefault.png')" />
      </a-form-item>
      <a-form-item :wrapper-col="{offset:3}">
        <a-button type="primary" v-has:pickUpCouponSetting="update" class='m-l-30 m-t-10 m-r-10'>
          保存
        </a-button>
      </a-form-item>
    </a-form>
  </a-card>
</template>
<script>
import { getVoucherShowConfig, updateVoucherShowConfig } from "@/api/assets";
import { iscode } from "@/utils/app";
import { onMounted, ref } from "@vue/runtime-core";
import store from "@/store";
export default {
  setup() {
    const detail = ref({
      promotional_img: "",
    });
    const initData = async () => {
      let result = await getVoucherShowConfig()
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(result, true, false)) {
        detail.value = result.data;
      }
    };
    onMounted(() => {
      initData();
    });
    const update = async () => {
      let result = await updateVoucherShowConfig(detail.value)
        .then((res) => res.data)
        .catch((error) => error);
      iscode(result, true);
    };
    return {
      detail,
      update,
      info: store.state.user.info,
    };
  },
};
</script>

<style lang="less" scoped>
.moduleContent {
  width: 285px;
  min-height: 600px;
  height: auto;
  background: #fdfdfd;
  border: 1px solid #ddd;
  padding: 15px 10px;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  user-select: none;
}
.pic_content {
  position: relative;
  height: 100%;
  background-position: center;
  background-size: cover;
}
video {
  width: 100%;
  height: 100%;
}
</style>